import { Lesson } from "@jelly/lesson";
import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "0bed1cc9-33b5-411f-b57c-c9b548357dff",
  publicId: "27",
  name: "Towards more sustainable and low-energy produced materials for buildings",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
